/**
 * TEÁOR'25 code → Bookkeepie industry (same idea as `TEAOR_TO_INDUSTRY` in teaorMapping.js).
 * Generated from official structure CSV (Kód + NACE section letters A–V).
 */

import { getIndustrySlugForCodePrefix } from "./teaorMapping.js";

/** Normalized TEÁOR'25 activity code → industry slug (keys: trim, comma → dot, no whitespace). */
export const TEAOR25_TO_INDUSTRY = {
  '1': 'agriculture',
  '1.1': 'agriculture',
  '1.11': 'agriculture',
  '1.12': 'agriculture',
  '1.13': 'agriculture',
  '1.14': 'agriculture',
  '1.15': 'agriculture',
  '1.16': 'agriculture',
  '1.19': 'agriculture',
  '1.2': 'agriculture',
  '1.21': 'agriculture',
  '1.22': 'agriculture',
  '1.23': 'agriculture',
  '1.24': 'agriculture',
  '1.25': 'agriculture',
  '1.26': 'agriculture',
  '1.27': 'agriculture',
  '1.28': 'agriculture',
  '1.29': 'agriculture',
  '1.3': 'agriculture',
  '1.4': 'agriculture',
  '1.41': 'agriculture',
  '1.42': 'agriculture',
  '1.43': 'agriculture',
  '1.44': 'agriculture',
  '1.45': 'agriculture',
  '1.46': 'agriculture',
  '1.47': 'agriculture',
  '1.48': 'agriculture',
  '1.5': 'agriculture',
  '1.6': 'agriculture',
  '1.61': 'agriculture',
  '1.62': 'agriculture',
  '1.63': 'agriculture',
  '1.7': 'agriculture',
  '2': 'agriculture',
  '2.1': 'agriculture',
  '2.2': 'agriculture',
  '2.3': 'agriculture',
  '2.4': 'agriculture',
  '3': 'agriculture',
  '3.1': 'agriculture',
  '3.11': 'agriculture',
  '3.12': 'agriculture',
  '3.2': 'agriculture',
  '3.21': 'agriculture',
  '3.22': 'agriculture',
  '3.3': 'agriculture',
  '5': 'other',
  '5.1': 'other',
  '5.2': 'other',
  '6': 'other',
  '6.1': 'other',
  '6.2': 'other',
  '7': 'other',
  '7.1': 'other',
  '7.2': 'other',
  '7.21': 'other',
  '7.29': 'other',
  '8': 'other',
  '8.1': 'other',
  '8.11': 'other',
  '8.12': 'other',
  '8.9': 'other',
  '8.91': 'other',
  '8.92': 'other',
  '8.93': 'other',
  '8.99': 'other',
  '9': 'other',
  '9.1': 'other',
  '9.9': 'other',
  '10': 'manufacturing',
  '10.1': 'manufacturing',
  '10.11': 'manufacturing',
  '10.12': 'manufacturing',
  '10.13': 'manufacturing',
  '10.2': 'manufacturing',
  '10.3': 'manufacturing',
  '10.31': 'manufacturing',
  '10.32': 'manufacturing',
  '10.39': 'manufacturing',
  '10.4': 'manufacturing',
  '10.41': 'manufacturing',
  '10.42': 'manufacturing',
  '10.5': 'manufacturing',
  '10.51': 'manufacturing',
  '10.52': 'manufacturing',
  '10.6': 'manufacturing',
  '10.61': 'manufacturing',
  '10.62': 'manufacturing',
  '10.7': 'manufacturing',
  '10.71': 'manufacturing',
  '10.72': 'manufacturing',
  '10.73': 'manufacturing',
  '10.8': 'manufacturing',
  '10.81': 'manufacturing',
  '10.82': 'manufacturing',
  '10.83': 'manufacturing',
  '10.84': 'manufacturing',
  '10.85': 'manufacturing',
  '10.86': 'manufacturing',
  '10.89': 'manufacturing',
  '10.9': 'manufacturing',
  '10.91': 'manufacturing',
  '10.92': 'manufacturing',
  '11': 'manufacturing',
  '11.01': 'manufacturing',
  '11.02': 'manufacturing',
  '11.03': 'manufacturing',
  '11.04': 'manufacturing',
  '11.05': 'manufacturing',
  '11.06': 'manufacturing',
  '11.07': 'manufacturing',
  '12': 'manufacturing',
  '13': 'manufacturing',
  '13.1': 'manufacturing',
  '13.2': 'manufacturing',
  '13.3': 'manufacturing',
  '13.9': 'manufacturing',
  '13.91': 'manufacturing',
  '13.92': 'manufacturing',
  '13.93': 'manufacturing',
  '13.94': 'manufacturing',
  '13.95': 'manufacturing',
  '13.96': 'manufacturing',
  '13.99': 'manufacturing',
  '14': 'manufacturing',
  '14.1': 'manufacturing',
  '14.2': 'manufacturing',
  '14.21': 'manufacturing',
  '14.22': 'manufacturing',
  '14.23': 'manufacturing',
  '14.24': 'manufacturing',
  '14.29': 'manufacturing',
  '15': 'manufacturing',
  '15.1': 'manufacturing',
  '15.11': 'manufacturing',
  '15.12': 'manufacturing',
  '15.2': 'manufacturing',
  '16': 'manufacturing',
  '16.1': 'manufacturing',
  '16.11': 'manufacturing',
  '16.12': 'manufacturing',
  '16.2': 'manufacturing',
  '16.21': 'manufacturing',
  '16.22': 'manufacturing',
  '16.23': 'manufacturing',
  '16.24': 'manufacturing',
  '16.25': 'manufacturing',
  '16.26': 'manufacturing',
  '16.27': 'manufacturing',
  '16.28': 'manufacturing',
  '17': 'manufacturing',
  '17.1': 'manufacturing',
  '17.11': 'manufacturing',
  '17.12': 'manufacturing',
  '17.2': 'manufacturing',
  '17.21': 'manufacturing',
  '17.22': 'manufacturing',
  '17.23': 'manufacturing',
  '17.24': 'manufacturing',
  '17.25': 'manufacturing',
  '18': 'manufacturing',
  '18.1': 'manufacturing',
  '18.11': 'manufacturing',
  '18.12': 'manufacturing',
  '18.13': 'manufacturing',
  '18.14': 'manufacturing',
  '18.2': 'manufacturing',
  '19': 'manufacturing',
  '19.1': 'manufacturing',
  '19.2': 'manufacturing',
  '20': 'manufacturing',
  '20.1': 'manufacturing',
  '20.11': 'manufacturing',
  '20.12': 'manufacturing',
  '20.13': 'manufacturing',
  '20.14': 'manufacturing',
  '20.15': 'manufacturing',
  '20.16': 'manufacturing',
  '20.17': 'manufacturing',
  '20.2': 'manufacturing',
  '20.3': 'manufacturing',
  '20.4': 'manufacturing',
  '20.41': 'manufacturing',
  '20.42': 'manufacturing',
  '20.5': 'manufacturing',
  '20.51': 'manufacturing',
  '20.59': 'manufacturing',
  '20.6': 'manufacturing',
  '21': 'manufacturing',
  '21.1': 'manufacturing',
  '21.2': 'manufacturing',
  '22': 'manufacturing',
  '22.1': 'manufacturing',
  '22.11': 'manufacturing',
  '22.12': 'manufacturing',
  '22.2': 'manufacturing',
  '22.21': 'manufacturing',
  '22.22': 'manufacturing',
  '22.23': 'manufacturing',
  '22.24': 'manufacturing',
  '22.25': 'manufacturing',
  '22.26': 'manufacturing',
  '23': 'manufacturing',
  '23.1': 'manufacturing',
  '23.11': 'manufacturing',
  '23.12': 'manufacturing',
  '23.13': 'manufacturing',
  '23.14': 'manufacturing',
  '23.15': 'manufacturing',
  '23.2': 'manufacturing',
  '23.3': 'manufacturing',
  '23.31': 'manufacturing',
  '23.32': 'manufacturing',
  '23.4': 'manufacturing',
  '23.41': 'manufacturing',
  '23.42': 'manufacturing',
  '23.43': 'manufacturing',
  '23.44': 'manufacturing',
  '23.45': 'manufacturing',
  '23.5': 'manufacturing',
  '23.51': 'manufacturing',
  '23.52': 'manufacturing',
  '23.6': 'manufacturing',
  '23.61': 'manufacturing',
  '23.62': 'manufacturing',
  '23.63': 'manufacturing',
  '23.64': 'manufacturing',
  '23.65': 'manufacturing',
  '23.66': 'manufacturing',
  '23.7': 'manufacturing',
  '23.9': 'manufacturing',
  '23.91': 'manufacturing',
  '23.99': 'manufacturing',
  '24': 'manufacturing',
  '24.1': 'manufacturing',
  '24.2': 'manufacturing',
  '24.3': 'manufacturing',
  '24.31': 'manufacturing',
  '24.32': 'manufacturing',
  '24.33': 'manufacturing',
  '24.34': 'manufacturing',
  '24.4': 'manufacturing',
  '24.41': 'manufacturing',
  '24.42': 'manufacturing',
  '24.43': 'manufacturing',
  '24.44': 'manufacturing',
  '24.45': 'manufacturing',
  '24.46': 'manufacturing',
  '24.5': 'manufacturing',
  '24.51': 'manufacturing',
  '24.52': 'manufacturing',
  '24.53': 'manufacturing',
  '24.54': 'manufacturing',
  '25': 'manufacturing',
  '25.1': 'manufacturing',
  '25.11': 'manufacturing',
  '25.12': 'manufacturing',
  '25.2': 'manufacturing',
  '25.21': 'manufacturing',
  '25.22': 'manufacturing',
  '25.3': 'manufacturing',
  '25.4': 'manufacturing',
  '25.5': 'manufacturing',
  '25.51': 'manufacturing',
  '25.52': 'manufacturing',
  '25.53': 'manufacturing',
  '25.6': 'manufacturing',
  '25.61': 'manufacturing',
  '25.62': 'manufacturing',
  '25.63': 'manufacturing',
  '25.9': 'manufacturing',
  '25.91': 'manufacturing',
  '25.92': 'manufacturing',
  '25.93': 'manufacturing',
  '25.94': 'manufacturing',
  '25.99': 'manufacturing',
  '26': 'manufacturing',
  '26.1': 'manufacturing',
  '26.11': 'manufacturing',
  '26.12': 'manufacturing',
  '26.2': 'manufacturing',
  '26.3': 'manufacturing',
  '26.4': 'manufacturing',
  '26.5': 'manufacturing',
  '26.51': 'manufacturing',
  '26.52': 'manufacturing',
  '26.6': 'manufacturing',
  '26.7': 'manufacturing',
  '27': 'manufacturing',
  '27.1': 'manufacturing',
  '27.11': 'manufacturing',
  '27.12': 'manufacturing',
  '27.2': 'manufacturing',
  '27.3': 'manufacturing',
  '27.31': 'manufacturing',
  '27.32': 'manufacturing',
  '27.33': 'manufacturing',
  '27.4': 'manufacturing',
  '27.5': 'manufacturing',
  '27.51': 'manufacturing',
  '27.52': 'manufacturing',
  '27.9': 'manufacturing',
  '28': 'manufacturing',
  '28.1': 'manufacturing',
  '28.11': 'manufacturing',
  '28.12': 'manufacturing',
  '28.13': 'manufacturing',
  '28.14': 'manufacturing',
  '28.15': 'manufacturing',
  '28.2': 'manufacturing',
  '28.21': 'manufacturing',
  '28.22': 'manufacturing',
  '28.23': 'manufacturing',
  '28.24': 'manufacturing',
  '28.25': 'manufacturing',
  '28.29': 'manufacturing',
  '28.3': 'manufacturing',
  '28.4': 'manufacturing',
  '28.41': 'manufacturing',
  '28.42': 'manufacturing',
  '28.9': 'manufacturing',
  '28.91': 'manufacturing',
  '28.92': 'manufacturing',
  '28.93': 'manufacturing',
  '28.94': 'manufacturing',
  '28.95': 'manufacturing',
  '28.96': 'manufacturing',
  '28.97': 'manufacturing',
  '28.99': 'manufacturing',
  '29': 'manufacturing',
  '29.1': 'manufacturing',
  '29.2': 'manufacturing',
  '29.3': 'manufacturing',
  '29.31': 'manufacturing',
  '29.32': 'manufacturing',
  '30': 'manufacturing',
  '30.1': 'manufacturing',
  '30.11': 'manufacturing',
  '30.12': 'manufacturing',
  '30.13': 'manufacturing',
  '30.2': 'manufacturing',
  '30.3': 'manufacturing',
  '30.31': 'manufacturing',
  '30.32': 'manufacturing',
  '30.4': 'manufacturing',
  '30.9': 'manufacturing',
  '30.91': 'manufacturing',
  '30.92': 'manufacturing',
  '30.99': 'manufacturing',
  '31': 'manufacturing',
  '32': 'manufacturing',
  '32.1': 'manufacturing',
  '32.11': 'manufacturing',
  '32.12': 'manufacturing',
  '32.13': 'manufacturing',
  '32.2': 'manufacturing',
  '32.3': 'manufacturing',
  '32.4': 'manufacturing',
  '32.5': 'manufacturing',
  '32.9': 'manufacturing',
  '32.91': 'manufacturing',
  '32.99': 'manufacturing',
  '33': 'manufacturing',
  '33.1': 'manufacturing',
  '33.11': 'manufacturing',
  '33.12': 'manufacturing',
  '33.13': 'manufacturing',
  '33.14': 'manufacturing',
  '33.15': 'manufacturing',
  '33.16': 'manufacturing',
  '33.17': 'manufacturing',
  '33.18': 'manufacturing',
  '33.19': 'manufacturing',
  '33.2': 'manufacturing',
  '35': 'other',
  '35.1': 'other',
  '35.11': 'other',
  '35.12': 'other',
  '35.13': 'other',
  '35.14': 'other',
  '35.15': 'other',
  '35.16': 'other',
  '35.2': 'other',
  '35.21': 'other',
  '35.22': 'other',
  '35.23': 'other',
  '35.24': 'other',
  '35.3': 'other',
  '35.4': 'other',
  '36': 'other',
  '37': 'other',
  '38': 'other',
  '38.1': 'other',
  '38.11': 'other',
  '38.12': 'other',
  '38.2': 'other',
  '38.21': 'other',
  '38.22': 'other',
  '38.23': 'other',
  '38.3': 'other',
  '38.31': 'other',
  '38.32': 'other',
  '38.33': 'other',
  '39': 'other',
  '41': 'construction',
  '42': 'construction',
  '42.1': 'construction',
  '42.11': 'construction',
  '42.12': 'construction',
  '42.13': 'construction',
  '42.2': 'construction',
  '42.21': 'construction',
  '42.22': 'construction',
  '42.9': 'construction',
  '42.91': 'construction',
  '42.99': 'construction',
  '43': 'construction',
  '43.1': 'construction',
  '43.11': 'construction',
  '43.12': 'construction',
  '43.13': 'construction',
  '43.2': 'construction',
  '43.21': 'construction',
  '43.22': 'construction',
  '43.23': 'construction',
  '43.24': 'construction',
  '43.3': 'construction',
  '43.31': 'construction',
  '43.32': 'construction',
  '43.33': 'construction',
  '43.34': 'construction',
  '43.35': 'construction',
  '43.4': 'construction',
  '43.41': 'construction',
  '43.42': 'construction',
  '43.5': 'construction',
  '43.6': 'construction',
  '43.9': 'construction',
  '43.91': 'construction',
  '43.99': 'construction',
  '45.11': 'retail',
  '45.19': 'retail',
  '45.31': 'wholesale',
  '45.32': 'retail',
  '46': 'wholesale',
  '46.1': 'wholesale',
  '46.11': 'wholesale',
  '46.12': 'wholesale',
  '46.13': 'wholesale',
  '46.14': 'wholesale',
  '46.15': 'wholesale',
  '46.16': 'wholesale',
  '46.17': 'wholesale',
  '46.18': 'wholesale',
  '46.19': 'wholesale',
  '46.2': 'wholesale',
  '46.21': 'wholesale',
  '46.22': 'wholesale',
  '46.23': 'wholesale',
  '46.24': 'wholesale',
  '46.3': 'wholesale',
  '46.31': 'wholesale',
  '46.32': 'wholesale',
  '46.33': 'wholesale',
  '46.34': 'wholesale',
  '46.35': 'wholesale',
  '46.36': 'wholesale',
  '46.37': 'wholesale',
  '46.38': 'wholesale',
  '46.39': 'wholesale',
  '46.4': 'wholesale',
  '46.41': 'wholesale',
  '46.42': 'wholesale',
  '46.43': 'wholesale',
  '46.44': 'wholesale',
  '46.45': 'wholesale',
  '46.46': 'wholesale',
  '46.47': 'wholesale',
  '46.48': 'wholesale',
  '46.49': 'wholesale',
  '46.5': 'wholesale',
  '46.6': 'wholesale',
  '46.61': 'wholesale',
  '46.62': 'wholesale',
  '46.63': 'wholesale',
  '46.64': 'wholesale',
  '46.7': 'wholesale',
  '46.71': 'wholesale',
  '46.72': 'wholesale',
  '46.73': 'wholesale',
  '46.8': 'wholesale',
  '46.81': 'wholesale',
  '46.82': 'wholesale',
  '46.83': 'wholesale',
  '46.84': 'wholesale',
  '46.85': 'wholesale',
  '46.86': 'wholesale',
  '46.87': 'wholesale',
  '46.89': 'wholesale',
  '46.9': 'wholesale',
  '47': 'retail',
  '47.1': 'retail',
  '47.11': 'retail',
  '47.12': 'retail',
  '47.2': 'retail',
  '47.21': 'retail',
  '47.22': 'retail',
  '47.23': 'retail',
  '47.24': 'retail',
  '47.25': 'retail',
  '47.26': 'retail',
  '47.27': 'retail',
  '47.3': 'retail',
  '47.4': 'retail',
  '47.5': 'retail',
  '47.51': 'retail',
  '47.52': 'retail',
  '47.53': 'retail',
  '47.54': 'retail',
  '47.55': 'retail',
  '47.6': 'retail',
  '47.61': 'retail',
  '47.62': 'retail',
  '47.63': 'retail',
  '47.64': 'retail',
  '47.69': 'retail',
  '47.7': 'retail',
  '47.71': 'retail',
  '47.72': 'retail',
  '47.73': 'retail',
  '47.74': 'retail',
  '47.75': 'retail',
  '47.76': 'retail',
  '47.77': 'retail',
  '47.78': 'retail',
  '47.79': 'retail',
  '47.8': 'retail',
  '47.81': 'retail',
  '47.82': 'retail',
  '47.83': 'retail',
  '47.9': 'retail',
  '47.91': 'etrade',
  '47.92': 'retail',
  '49': 'logistics',
  '49.1': 'logistics',
  '49.11': 'logistics',
  '49.12': 'logistics',
  '49.2': 'logistics',
  '49.3': 'logistics',
  '49.31': 'logistics',
  '49.32': 'logistics',
  '49.33': 'logistics',
  '49.34': 'logistics',
  '49.39': 'logistics',
  '49.4': 'logistics',
  '49.41': 'logistics',
  '49.42': 'logistics',
  '49.5': 'logistics',
  '50': 'logistics',
  '50.1': 'logistics',
  '50.2': 'logistics',
  '50.3': 'logistics',
  '50.4': 'logistics',
  '51': 'logistics',
  '51.1': 'logistics',
  '51.2': 'logistics',
  '51.21': 'logistics',
  '51.22': 'logistics',
  '52': 'logistics',
  '52.1': 'logistics',
  '52.2': 'logistics',
  '52.21': 'logistics',
  '52.22': 'logistics',
  '52.23': 'logistics',
  '52.24': 'logistics',
  '52.25': 'logistics',
  '52.26': 'logistics',
  '52.3': 'logistics',
  '52.31': 'logistics',
  '52.32': 'logistics',
  '53': 'courier',
  '53.1': 'courier',
  '53.2': 'courier',
  '53.3': 'courier',
  '55': 'travel',
  '55.1': 'travel',
  '55.2': 'travel',
  '55.3': 'travel',
  '55.4': 'travel',
  '55.9': 'travel',
  '56': 'travel',
  '56.1': 'travel',
  '56.11': 'travel',
  '56.12': 'travel',
  '56.2': 'travel',
  '56.21': 'travel',
  '56.22': 'travel',
  '56.3': 'travel',
  '56.4': 'travel',
  '58': 'otherservices',
  '58.1': 'otherservices',
  '58.11': 'otherservices',
  '58.12': 'otherservices',
  '58.13': 'otherservices',
  '58.19': 'otherservices',
  '58.2': 'otherservices',
  '58.21': 'otherservices',
  '58.29': 'otherservices',
  '59': 'otherservices',
  '59.1': 'otherservices',
  '59.11': 'otherservices',
  '59.12': 'otherservices',
  '59.13': 'otherservices',
  '59.14': 'otherservices',
  '59.2': 'otherservices',
  '60': 'otherservices',
  '60.1': 'otherservices',
  '60.2': 'otherservices',
  '60.3': 'otherservices',
  '60.31': 'otherservices',
  '60.39': 'otherservices',
  '61': 'otherservices',
  '61.1': 'otherservices',
  '61.2': 'otherservices',
  '61.9': 'otherservices',
  '62': 'otherservices',
  '62.1': 'otherservices',
  '62.2': 'otherservices',
  '62.9': 'otherservices',
  '63': 'it',
  '63.1': 'it',
  '63.9': 'it',
  '63.91': 'it',
  '63.92': 'it',
  '64': 'finance',
  '64.1': 'finance',
  '64.11': 'finance',
  '64.19': 'finance',
  '64.2': 'finance',
  '64.21': 'finance',
  '64.22': 'finance',
  '64.3': 'finance',
  '64.31': 'finance',
  '64.32': 'finance',
  '64.9': 'finance',
  '64.91': 'finance',
  '64.92': 'finance',
  '64.99': 'finance',
  '65': 'finance',
  '65.1': 'finance',
  '65.11': 'finance',
  '65.12': 'finance',
  '65.2': 'finance',
  '65.3': 'finance',
  '66': 'finance',
  '66.1': 'finance',
  '66.11': 'finance',
  '66.12': 'finance',
  '66.19': 'finance',
  '66.2': 'finance',
  '66.21': 'finance',
  '66.22': 'finance',
  '66.29': 'finance',
  '66.3': 'finance',
  '68': 'realestate',
  '68.1': 'realestate',
  '68.11': 'realestate',
  '68.12': 'realestate',
  '68.2': 'realestate',
  '68.3': 'realestate',
  '68.31': 'realestate',
  '68.32': 'realestate',
  '69': 'otherservices',
  '69.1': 'lawyer',
  '69.2': 'otherservices',
  '70': 'consultancy',
  '70.1': 'consultancy',
  '70.2': 'consultancy',
  '71': 'engineer',
  '71.1': 'engineer',
  '71.11': 'engineer',
  '71.12': 'engineer',
  '71.2': 'engineer',
  '72': 'other',
  '72.1': 'other',
  '72.2': 'other',
  '73': 'otherservices',
  '73.1': 'otherservices',
  '73.11': 'otherservices',
  '73.12': 'otherservices',
  '73.2': 'otherservices',
  '73.3': 'otherservices',
  '74': 'other',
  '74.1': 'other',
  '74.11': 'other',
  '74.12': 'other',
  '74.13': 'other',
  '74.14': 'other',
  '74.2': 'other',
  '74.3': 'other',
  '74.9': 'other',
  '74.91': 'other',
  '74.99': 'other',
  '75': 'medicine',
  '77': 'otherservices',
  '77.1': 'otherservices',
  '77.11': 'otherservices',
  '77.12': 'otherservices',
  '77.2': 'otherservices',
  '77.21': 'otherservices',
  '77.22': 'otherservices',
  '77.3': 'otherservices',
  '77.31': 'otherservices',
  '77.32': 'otherservices',
  '77.33': 'otherservices',
  '77.34': 'otherservices',
  '77.35': 'otherservices',
  '77.39': 'otherservices',
  '77.4': 'otherservices',
  '77.5': 'otherservices',
  '77.51': 'otherservices',
  '77.52': 'otherservices',
  '78': 'otherservices',
  '78.1': 'otherservices',
  '78.2': 'otherservices',
  '79': 'otherservices',
  '79.1': 'otherservices',
  '79.11': 'otherservices',
  '79.12': 'otherservices',
  '79.9': 'otherservices',
  '80': 'otherservices',
  '80.01': 'otherservices',
  '80.09': 'otherservices',
  '81': 'otherservices',
  '81.1': 'otherservices',
  '81.2': 'otherservices',
  '81.21': 'otherservices',
  '81.22': 'otherservices',
  '81.23': 'otherservices',
  '81.3': 'otherservices',
  '82': 'otherservices',
  '82.1': 'otherservices',
  '82.2': 'otherservices',
  '82.3': 'otherservices',
  '82.4': 'otherservices',
  '82.9': 'otherservices',
  '82.91': 'otherservices',
  '82.92': 'otherservices',
  '82.99': 'otherservices',
  '84': 'other',
  '84.1': 'other',
  '84.11': 'other',
  '84.12': 'other',
  '84.13': 'other',
  '84.2': 'other',
  '84.21': 'other',
  '84.22': 'other',
  '84.23': 'other',
  '84.24': 'other',
  '84.25': 'other',
  '84.3': 'other',
  '85': 'education',
  '85.1': 'education',
  '85.2': 'education',
  '85.3': 'education',
  '85.31': 'education',
  '85.32': 'education',
  '85.33': 'education',
  '85.4': 'education',
  '85.5': 'education',
  '85.51': 'education',
  '85.52': 'education',
  '85.53': 'education',
  '85.59': 'education',
  '85.6': 'education',
  '85.61': 'education',
  '85.69': 'education',
  '86': 'medicine',
  '86.1': 'medicine',
  '86.2': 'medicine',
  '86.21': 'medicine',
  '86.22': 'medicine',
  '86.23': 'medicine',
  '86.9': 'medicine',
  '86.91': 'medicine',
  '86.92': 'medicine',
  '86.93': 'medicine',
  '86.94': 'medicine',
  '86.95': 'medicine',
  '86.96': 'medicine',
  '86.97': 'medicine',
  '86.99': 'medicine',
  '87': 'otherservices',
  '87.1': 'otherservices',
  '87.2': 'otherservices',
  '87.3': 'otherservices',
  '87.9': 'otherservices',
  '87.91': 'otherservices',
  '87.99': 'otherservices',
  '88': 'otherservices',
  '88.1': 'otherservices',
  '88.9': 'otherservices',
  '88.91': 'otherservices',
  '88.99': 'otherservices',
  '90': 'art',
  '90.1': 'art',
  '90.11': 'art',
  '90.12': 'art',
  '90.13': 'art',
  '90.2': 'art',
  '90.3': 'art',
  '90.31': 'art',
  '90.39': 'art',
  '91': 'other',
  '91.1': 'other',
  '91.11': 'other',
  '91.12': 'other',
  '91.2': 'other',
  '91.21': 'other',
  '91.22': 'other',
  '91.3': 'other',
  '91.4': 'other',
  '91.41': 'other',
  '91.42': 'other',
  '92': 'other',
  '93': 'sport',
  '93.1': 'sport',
  '93.11': 'sport',
  '93.12': 'sport',
  '93.13': 'sport',
  '93.19': 'sport',
  '93.2': 'sport',
  '93.21': 'sport',
  '93.29': 'sport',
  '94': 'other',
  '94.1': 'other',
  '94.11': 'other',
  '94.12': 'other',
  '94.2': 'other',
  '94.9': 'other',
  '94.91': 'other',
  '94.92': 'other',
  '94.99': 'other',
  '95': 'vehicle',
  '95.1': 'vehicle',
  '95.2': 'vehicle',
  '95.21': 'vehicle',
  '95.22': 'vehicle',
  '95.23': 'vehicle',
  '95.24': 'vehicle',
  '95.25': 'vehicle',
  '95.29': 'vehicle',
  '95.3': 'vehicle',
  '95.31': 'vehicle',
  '95.32': 'vehicle',
  '95.4': 'vehicle',
  '96': 'otherservices',
  '96.1': 'otherservices',
  '96.2': 'beauty',
  '96.21': 'beauty',
  '96.22': 'beauty',
  '96.23': 'beauty',
  '96.3': 'otherservices',
  '96.4': 'otherservices',
  '96.9': 'otherservices',
  '96.91': 'otherservices',
  '96.99': 'otherservices',
  '97': 'other',
  '98': 'other',
  '98.1': 'other',
  '98.2': 'other',
  '99': 'other',
};

const TEAOR25_CODE_PREFIXES_LONGEST_FIRST =
  (Object.entries(TEAOR25_TO_INDUSTRY))
    .map(([code, industry]) => ({ code, industry }))
    .sort((a, b) => b.code.length - a.code.length);

/** Normalize TEÁOR'25 display code: trim, comma → dot, remove whitespace. */
export function normalizeTeaor25Code(raw) {
  if (raw === undefined || raw === null) return '';
  return String(raw).trim().replace(/,/g, '.').replace(/\s+/g, '');
}

const stripLeadingZerosFromTeaor25Segment = (segment) => {
  if (!segment) return segment;
  const stripped = segment.replace(/^0+(\d)/, '$1');
  return stripped === '' ? '0' : stripped;
};

/**
 * Align padded top-level section codes with TEÁOR'25 keys: `01` → `1`, `01.27` → `1.27`.
 * Only the first segment is adjusted (`62.01` stays `62.01`).
 */
export function normalizeTeaor25SegmentLeadingZeros(raw) {
  const n = normalizeTeaor25Code(raw);
  if (!n) return '';
  if (!n.includes('.')) return stripLeadingZerosFromTeaor25Segment(n);
  const [first, ...rest] = n.split('.');
  return [stripLeadingZerosFromTeaor25Segment(first), ...rest].join('.');
}

/** Strip to digits only (legacy NACE-style fallback; not used for TEÁOR'25 prefix match). */
export function normalizeTeaor25Digits(raw) {
  if (raw === undefined || raw === null) return '';
  return String(raw).replace(/\D/g, '');
}

/**
 * Map a TEÁOR'25 activity code to a Bookkeepie industry slug:
 * longest matching official `code` (exact, or input extends row with a further segment);
 * then legacy digit-prefix map (collapsed digit strings stay ambiguous, e.g. `111`).
 */
export function getIndustrySlugForTeaor25(code) {
  const n = normalizeTeaor25SegmentLeadingZeros(code);
  if (!n) return undefined;
  for (const row of TEAOR25_CODE_PREFIXES_LONGEST_FIRST) {
    if (n === row.code || n.startsWith(row.code + '.')) return row.industry;
  }
  const d = normalizeTeaor25Digits(code);
  if (!d) return undefined;
  return getIndustrySlugForCodePrefix(d);
}
